import { render } from "./MaterialTitleSection.vue?vue&type=template&id=df73c490&scoped=true"
import script from "./MaterialTitleSection.vue?vue&type=script&lang=js"
export * from "./MaterialTitleSection.vue?vue&type=script&lang=js"

import "./MaterialTitleSection.vue?vue&type=style&index=0&id=df73c490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df73c490"]])

export default __exports__